import { Box, ButtonWithLink, Stack, constants } from "@thecb/components";
import React from "react";
import { Pages } from "../../types";
interface NavigationItem {
  associatedHeading: string;
  linkText: string;
  url: string;
}

const navigationConfig: NavigationItem[] = [
  {
    associatedHeading: "Cashiering Client Settings",
    linkText: "Client",
    url: "/pos-config/clients/edit",
  },
  {
    associatedHeading: "Locations",
    linkText: "Locations",
    url: "/pos-config/locations",
  },
  {
    associatedHeading: "Agencies",
    linkText: "Agencies",
    url: "/pos-config/agencies",
  },
  {
    associatedHeading: "Terminals",
    linkText: "Terminals",
    url: "/pos-config/terminals",
  },
];

const Navigation = (props: { page: Pages }) => {
  const selection = navigationConfig.find(
    (navItem) => navItem.linkText === props.page
  );
  return (
    <>
      <Box padding="0 0 0.5rem">
        <Stack direction="row" justify="space-between" role="navigation">
          <Stack direction="row" childGap="0.5rem">
            {navigationConfig.map((navItem) => (
              <ButtonWithLink
                key={navItem.associatedHeading}
                aria-current={
                  selection?.associatedHeading === navItem.associatedHeading
                }
                extraStyles={`
                  min-width: fit-content;
                  border-radius: 19px;
                  border-width: 1px;
                  margin: 0;
                  background-color: ${
                    selection?.associatedHeading === navItem.associatedHeading
                      ? constants.colors.HAWKES_BLUE
                      : "transparent"
                  }
                `}
                linkExtraStyles={`text-decoration: none;`}
                text={navItem.linkText}
                url={navItem.url}
                isLoading={false}
                variant="secondary"
              />
            ))}
          </Stack>
        </Stack>
      </Box>
    </>
  );
};

export default Navigation;
